import { QueryHookOptions, useQuery } from '@apollo/react-hooks'
import { BLOG_TAGS_QUERY } from 'apollo'
import { merge } from 'merge-anything'

const DEFAULTS = {
  variables: {
    query: {
      key: process.env.NEXT_PUBLIC_CONTENT_API_KEY,
      limit: 'all',
      filter: 'slug:-[testimonios,archivo]',
    },
  },
}

export const useBlogTagsQuery = (options: QueryHookOptions<any, any> = {}) =>
  useQuery(BLOG_TAGS_QUERY, merge(DEFAULTS, options))
